module.exports = __webpack_public_path__ + "static/media/rating-star-full.b1499082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rating-star-full.svg
// module id = 430
// module chunks = 0